<template>
  <div class="login-success-test-page">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6">
          <div class="success-card">
            <div class="success-icon">
              <i class="fa fa-check-circle"></i>
            </div>
            <h1 class="success-title">登录成功！</h1>
            <p class="success-message">您已成功登录系统</p>
            
            <div class="user-info" v-if="userInfo">
              <h3>用户信息</h3>
              <div class="info-item">
                <strong>用户名：</strong>
                <span>{{ userInfo.username || userInfo.empCompanyId || 'N/A' }}</span>
              </div>
              <div class="info-item" v-if="userInfo.userType">
                <strong>用户类型：</strong>
                <span>{{ userInfo.userType }}</span>
              </div>
              <div class="info-item" v-if="userInfo.empCompanyId">
                <strong>公司ID：</strong>
                <span>{{ userInfo.empCompanyId }}</span>
              </div>
            </div>

            <div class="login-details">
              <h3>登录详情</h3>
              <div class="info-item">
                <strong>登录时间：</strong>
                <span>{{ loginTime }}</span>
              </div>
              <div class="info-item" v-if="loginMethod">
                <strong>登录方式：</strong>
                <span>{{ loginMethod }}</span>
              </div>
            </div>

            <div class="action-buttons">
              <button class="btn btn-primary" @click="goBack">
                返回登录页
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginSuccessTest',
  data() {
    return {
      userInfo: null,
      loginTime: '',
      loginMethod: ''
    };
  },
  created() {
    // 从 localStorage 获取用户信息
    const user = localStorage.getItem('user');
    if (user) {
      try {
        this.userInfo = JSON.parse(user);
      } catch (e) {
        console.error('Failed to parse user info:', e);
      }
    }

    // 从 store 获取用户信息
    if (this.$store.state.authentication?.user) {
      this.userInfo = this.$store.state.authentication.user;
    }

    // 设置登录时间
    this.loginTime = new Date().toLocaleString('zh-CN');

    // 从路由参数获取登录方式
    if (this.$route.query.loginMethod) {
      this.loginMethod = this.$route.query.loginMethod;
    }
  },
  methods: {
    /**
     * 返回登录页面
     * 清除登录状态并跳转到登录页（/auth/login）
     */
    goBack() {
      // 清除登录状态
      this.$store.dispatch('authentication/logout');
      
      // 跳转到登录页 /auth/login，保留查询参数（如果有）
      this.$router.push({
        path: '/auth/login',
        query: this.$route.query
      });
    }
  }
};
</script>

<style scoped>
.login-success-test-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.success-card {
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.success-icon {
  font-size: 80px;
  color: #28a745;
  margin-bottom: 20px;
}

.success-icon i {
  animation: scaleIn 0.5s ease-out;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.success-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.success-message {
  font-size: 18px;
  color: #666;
  margin-bottom: 30px;
}

.user-info,
.login-details {
  text-align: left;
  margin: 20px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.user-info h3,
.login-details h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 15px;
  border-bottom: 2px solid #667eea;
  padding-bottom: 10px;
}

.info-item {
  margin: 10px 0;
  font-size: 16px;
  color: #555;
}

.info-item strong {
  color: #333;
  margin-right: 10px;
}

.action-buttons {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

.btn {
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background: #667eea;
  color: white;
}

.btn-primary:hover {
  background: #5568d3;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(108, 117, 125, 0.4);
}
</style>

